import React, { Suspense } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Tabs,
  Tab,
  Menu,
  withWidth,
} from "@material-ui/core";
import { withStyles, withTheme } from "@material-ui/core/styles";
import { Navigate } from "react-router-dom";
import { compose } from "recompose";
import { isEqual } from "lodash/lang";
import { observer, inject } from "mobx-react";
import { autorun } from "mobx";
import { withUserProfile } from "../../../userProfile/userProfileContext";
import Events from "../../../utilities/EventEmitter";
import { withSnackbar } from "notistack";
import appConstants from "../../../appConstants";
import MoreVert from "@material-ui/icons/MoreVert";
import Tooltip from "../../common/StyledToolTip";
import RefreshIconButton from "../../common/RefreshIconButton";
import styles from "../headerStyles";
import ModuleSwitcher from "../ModuleSwitcher";
import RightNavigationMenu from "./rightNavigationMenu";
import { AppLoading } from "../../../loaders/loaders";
import { cloneDeep } from "lodash";
import {
  getSelectedMapFilters,
} from "../../modules/Dispatch/RouteExecution/filterUtils";
import ToastNotifications from "./Notifications/ToastNotifications";
import {
  alertNewToBeReviewedPickups,
  buildNavigateToToBeReviewedPayload,
} from "./Notifications/utils";
import ParameterListener from "../Parameters";
import {
  getDriverRoutesData,
  getAllPickupsData,
  sanitizeQueryParams,
  getRouteMappingData,
  shouldHandleAsTrailerMovePickup,
} from "./utils";
import { RMAXLogger } from "../../../services/LoggerService/RMAXLogger";
import { withAppConfig } from "../../../appConfigContext";
import pickupOperationsLogger from "./PickupEventHandler/PickupOperationsLogger";
import {
  setBatchLocationUpdateConfig,
  setBatchLocationUpdateInterval,
  clearDriverLocationMappingCache,
  deleteDriversLocationCache
} from '../../../signalR/eventHandlers/driverLocationHandler';
import withRouter from "../../../routes/withRouter";
import { fetchDispatchStaticData } from '../../../utilities/fetchData';
import { withFeatureFlags } from '../../../userProfile/featureFlagsContext';
import PickupConfirmationHandler from "../../modules/Dispatch/RouteExecution/utils/PickupConfirmationHandler";
import { createPickupArrivalBatcher } from "./PickupArrivalBatcher";
import { APP_EVENT_NAMES } from "../../../signalR/constants";
import { NAVIGATE_TO_TO_BE_REVIEWED_PICKUP_ON_GRID } from "./Notifications/constants";

const { DISPATCH } = APP_EVENT_NAMES;
import {
  handleTrailerMovesPickupEvent,
  handleTrailerMovesUpdatedEvent,
  refreshSwapBoard,
} from "../../modules/Dispatch/RouteExecution/TrailerMoves/swapBoardService";

const DispatchOptimizationDialog = React.lazy(() =>
  import("./PickupOptimization")
);
const PickupEventHandler = React.lazy(() => import("./PickupEventHandler"));

const DispatchTabs = {
  assetManagement: {
    label: "Asset Management",
    id: "AssetManagementHeader",
    path: appConstants.NAV_URLS.DISPATCH_ASSET_MANAGEMENT,
  },
  routeExecution: {
    label: "Route Execution",
    id: "RoutesExecutionHeader",
    path: appConstants.NAV_URLS.DISPATCH_ROUTEEXECUTION,
  },
  driverPerformance: {
    label: "Driver Performance",
    id: "DriverPerformanceHeader",
    path: appConstants.NAV_URLS.REPORT_DRIVER_PERFORMANCE_LIVE,
  },
};

@inject("DispatchStore", "CommonStore")
@observer
class DispatchHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTabValue:
        this.props.router.location.pathname
          ? this.props.router.location.pathname.toLowerCase()
          : false,
      isDataRefreshProgress: false,
      currentPlanDate: null,
      isDialogOpen: false,
      title: "",
      isPickupOptimizationInProgress: false,
      showNotification: false,
      proDetails : null
    };

    this.userProfileData = {
      terminal: this.props.userData.userProfile.terminal.code,
      userName: this.props.userData.userProfile.userName,
      planDate: this.props.userData.userProfile.planDate,
    };

    // Batches rapid-fire pickup-arrival events into one store mutation instead of
    // one per event, so a burst of N pickups triggers one grid rebuild, not N.
    this.pickupArrivalBatcher = createPickupArrivalBatcher({
      onFlush: (batch) => this.props.DispatchStore.applyPickupArrivalBatch(batch)
    });
  }

  componentDidMount() {
    this.props.DispatchStore.setTerminalOffset(
      this.props.userData.userProfile.terminal.offset,
    );
    const { configJSON } = this.props;
    this.props.DispatchStore.setClosingSoonTimeThresholds(
      configJSON.closingSoonWarningTimeLimit,
      configJSON.closingSoonAlertTimeLimit
    );
    Events.on("RedirectToPage", this.handleChange);
    Events.on("RefreshDispatchStore", this.refreshDispatchStore);
    Events.on("AddDriverLocation", this.addDriverLocation);
    Events.on("RefreshPickupsData", this.onPickupUpdated);
    Events.on("UpdateDriverLoginStatus", this.updateDriverLoginStatus);
    Events.on(
      "UpdatePickupAcknowledgedStatus",
      this.updatePickupAcknowledgedStatus
    );
    Events.on("stopMoved", this.stopMoved);
    this.updateMapFilters();
    Events.on("UpdateDriverRoute", this.updateDriverRoute);
    Events.on('updatePickupListInStore', this.updatePickupListInStore);
    Events.on('onDriverSelectInKPI', this.onDriverSelectInKPI);
    Events.on(DISPATCH.NavigateToToBeReviewedPickup, this.onNavigateToToBeReviewedPickup);
    Events.on("GeofenceArrivalDeparture", this.updateGeofenceArrivalDeparture);
    Events.on("updateDriverGateinGateout",this.updateDriverGateinGateout)
    Events.on("showProDetails",this.showProDetails)
    Events.on("dispatchCanceled",this.dispatchCanceled)
    Events.on("populateStaticData",this.populateStaticData)
    Events.on(appConstants.Event.HandleTrailerMovesEvent, this.onTrailerMovesPickupEvent);
    Events.on(appConstants.Event.TrailerMovesUpdated, this.onTrailerMovesUpdated);
    this.resetDispatchData();
    const { DispatchStore } = this.props;
    !DispatchStore.staticClientData && this.populateStaticData();
    this.handleBatchLocationUpdate();
    this.updateRouteMappingData();
    this.autoRunParameter= autorun(() => {  
      if (
        !isEqual(
          this.parametersData,
          this.props.CommonStore.parametersData
        )
      ) {
        this.parametersData = this.props.CommonStore.parametersData.slice();
        this.updateBatchLocationInterval();
      }
    })
  }

  componentWillUnmount() {
    Events.removeListener("RedirectToPage", this.handleChange);
    Events.removeListener("RefreshDispatchStore", this.refreshDispatchStore);
    Events.removeListener("AddDriverLocation", this.addDriverLocation);
    Events.removeListener("RefreshPickupsData", this.onPickupUpdated);
    Events.removeListener("UpdateDriverRoute", this.updateDriverRoute);
    Events.removeListener(
      "UpdateDriverLoginStatus",
      this.updateDriverLoginStatus
    );
    Events.removeListener(
      "UpdatePickupAcknowledgedStatus",
      this.updatePickupAcknowledgedStatus
    );
    Events.removeListener("stopMoved", this.stopMoved);
    Events.removeListener('updatePickupListInStore', this.updatePickupListInStore);
    Events.removeListener('onDriverSelectInKPI', this.onDriverSelectInKPI);
    Events.removeListener(DISPATCH.NavigateToToBeReviewedPickup, this.onNavigateToToBeReviewedPickup);
    Events.removeListener("GeofenceArrivalDeparture", this.updateGeofenceArrivalDeparture);
    Events.removeListener("updateDriverGateinGateout",this.updateDriverGateinGateout)
    Events.removeListener("dispatchCanceled", this.dispatchCanceled)
    Events.removeListener("showProDetails",this.showProDetails)
    this.pendingPickupEvent = null;
    this.handleBatchLocationUpdate(false);
    this.autoRunParameter?.();
    Events.removeListener("populateStaticData",this.populateStaticData)
    Events.removeListener(appConstants.Event.HandleTrailerMovesEvent, this.onTrailerMovesPickupEvent);
    Events.removeListener(appConstants.Event.TrailerMovesUpdated, this.onTrailerMovesUpdated);
    pickupOperationsLogger.cleanupOperationTrackingData();
    this.pickupArrivalBatcher.dispose();
  }

  componentDidUpdate(prevProps) {
    this.updateRouteColorsOnThemeChange(prevProps);
    const isTerminalChanged = this.props.userData.userProfile.terminal.id !== prevProps.userData.userProfile.terminal.id;
    if (
      isTerminalChanged ||
      this.props.userData.userProfile.scenarioID !== prevProps.userData.userProfile.scenarioID
    ) {
      this.resetDispatchData(true);
      this.props.router.navigate(this.props.router.location.pathname, { replace: true }); //when we switch terminal or scenario revert path to original
    }
    if (isTerminalChanged){
      this.updateRouteMappingData();
      this.handleBatchLocationUpdate();
    this.props.DispatchStore.setTerminalOffset(
      this.props.userData.userProfile.terminal.offset,
    );
    pickupOperationsLogger.cleanupOperationTrackingData();
    }
  }

  updateRouteColorsOnThemeChange = (prevProps) => {
    if (
      this.props.theme.themeName !== prevProps.theme.themeName &&
      this.props.DispatchStore.dispatchedDrivers?.length > 0
    ) {
      const { dispatchedDrivers, driverLocations } = this.props.DispatchStore;
      // Create a new array with driver location data merged into each driver object
      const driversWithLocations = dispatchedDrivers.map((driver) => {
        const driverId = driver.driverId?.toUpperCase();
        const locationData = driverLocations[driverId] || {};

        return {
          ...driver,
          lastKnownLatitude: locationData?.lat,
          lastKnowLongitude: locationData?.lng,
          lastConnectedTime: locationData?.lastConnectedTime
        };
      });

      this.props.DispatchStore.addDispatchedDrivers(
        driversWithLocations,
        this.props.theme.routeMapColorPalette.IconsColors
      );
    }
  };

  updateRouteMappingData = () => {
    const terminalId = this.props.userData.userProfile.terminal.id;
    getRouteMappingData(terminalId).then((data) => {
      this.props.DispatchStore.setRouteMappingData(data);
    });
  }

  updateBatchLocationInterval = () => {
    const batchLocationParam = this.props.CommonStore.parametersData.find(
      (param) => param.parameterName === 'BatchLocationUpdateIntervalInSeconds'
    );
    const intervalInSeconds = Number(batchLocationParam?.defaultValue || 0);
    const intervalInMilliseconds = intervalInSeconds * appConstants.ONE_SECOND_TIME_OUT;
    setBatchLocationUpdateInterval(intervalInMilliseconds);
  };

  handleBatchLocationUpdate = (shouldRunBatchUpdate = true) => {
    setBatchLocationUpdateConfig({
      shouldRunBatchUpdate,
      currentTerminalCode: this.props.userData.userProfile.terminal.code,
    });
  };

  resetDispatchData = (forceRefresh = false) => {
    if(this.state.isDataRefreshProgress && !forceRefresh){
      return
    }
    // Drop queued arrivals from the previous terminal/scenario so they cannot
    // land on the cleared (or newly fetched) list after the 100ms window.
    this.pickupArrivalBatcher.clear();
    this.refreshDispatchStore({ initialRefresh: true });
    this.props.DispatchStore.addPickups([]);
    this.props.DispatchStore.setAvailableDriverList([]);
    this.props.DispatchStore.addDispatchedDrivers([]);
    Events.emit('refreshDispatchKPI', true);
    if (this.props.configJSON?.enablePreDispatch){
      Events.emit('UpdatedClosedTrailers', { refreshDriver: false });
    }
    if (this.isTrailerSwapBoardEnabled()) {
      refreshSwapBoard(
        this.props.DispatchStore,
        this.props.userData.userProfile.terminal.code
      );
    }
  };

  isTrailerSwapBoardEnabled = () =>
    Boolean(this.props.configJSON?.enableTrailerSwapBoard);

  onTrailerMovesUpdated = (payload) => {
    if (!this.isTrailerSwapBoardEnabled()) {
      return;
    }
    handleTrailerMovesUpdatedEvent({
      dispatchStore: this.props.DispatchStore,
      terminalCode: this.props.userData.userProfile.terminal.code,
      payload,
    });
  };

  onTrailerMovesPickupEvent = (dataString, eventName) => {
    if (!this.isTrailerSwapBoardEnabled()) {
      return;
    }
    handleTrailerMovesPickupEvent({
      dispatchStore: this.props.DispatchStore,
      terminalCode: this.props.userData.userProfile.terminal.code,
      dataString,
      eventName,
    });
  };

  switchNotificationPanel = (value = null) => {
    this.setState((prevState) => ({
      showNotification: value ?? !prevState.showNotification,
    }));
  };

  updateDriverLoginStatus = (data) => {
    const { driverId } = data;
    this.refreshDispatchRoutes([driverId]);
  };

  dispatchCanceled = ({ eventName, driverId }) => {
    const currentDrivers = this.props.DispatchStore.currentActiveRoutes.map((currentDriver) =>
      currentDriver.driverId.toUpperCase()
    );
    if (currentDrivers.includes(driverId.toUpperCase())) {
      this.refreshDispatchStore({
        eventName,
        driverIds: [driverId]
      });
    }
  };

  updateMapFilters = () => {
    const stopFilter = getSelectedMapFilters(
      this.props.DispatchStore.stopsFilter
    );
    this.props.DispatchStore.updateMapFilter(stopFilter);
  };

  updateDriverRoute = (driverId) => {
    const driverIdList = Array.isArray(driverId)
      ? driverId.map((d) => d.toUpperCase())
      : driverId ? [driverId.toUpperCase()] : []
    if (!driverIdList.length) {
      return;
    }
    console.info(
      `Driver ${driverIdList.join(
        ", "
      )} update notification received at ${new Date().toLocaleString()}`
    );
    // fetch Data for pending driverIds
    return this.refreshDispatchRoutes(driverIdList);
  };

  addDriverLocation =(driversLocationMap) => {
    this.props.DispatchStore.addDriverLocation(driversLocationMap)
  }

  populateStaticData = (terminalCode) => {
    const {
      DispatchStore,
      userData: { userProfile }
    } = this.props;
    fetchDispatchStaticData(terminalCode || userProfile.terminal.code).then(
      ([clientCodes, hazmatInfo]) => {
        if (clientCodes.status === 200) {
          const { packageCodes, ...otherClientCodes } = clientCodes.data;
          DispatchStore.setStaticClientData({
            clientCodes: otherClientCodes,
            packageCodes: packageCodes
          });
        }
        if (hazmatInfo.status === 200) {
          DispatchStore.setHazmatInfo(hazmatInfo.data);
        }
      });
  };

  updatePickupAcknowledgedStatus = (data) => {
    const { routeId, pickupId } = JSON.parse(data);
    this.props.DispatchStore.updatePickupAcknowledgedStatus(routeId, pickupId);
  };

  refreshPickupList = (pickupToUpdate) => {
    const pickupIds = sanitizeQueryParams(pickupToUpdate);
    return getAllPickupsData(this.props.userData.userProfile.terminal.code, pickupIds)
      .then((pickups) => {
        if (pickups?.status === 200) {
          if (pickupIds.length) {
            // Server data wins for the refreshed ids — drop only those so a
            // different pickup still in the window can still flush.
            this.pickupArrivalBatcher.clearPickupIds(pickupIds);
            this.props.DispatchStore.updateMultiplePickups(
              pickups.data || [],
              this.props.userData.userProfile.terminal.code,
              pickupIds
            );
            alertNewToBeReviewedPickups(
              this.props.DispatchStore,
              this.state.showNotification
            );
          } else {
            this.pickupArrivalBatcher.clear();
            const pickupsList = this.updatePickupDataBasedOnFeatureFlags(pickups.data);
            this.props.DispatchStore.addPickups(pickupsList);
          }
            this.props.DispatchStore.showErrorMessageOnGrid(
              'pickupsGridMessage',
              appConstants.GRID_STATUS.SUCCESS
            );
        } else {
          this.props.DispatchStore.showErrorMessageOnGrid(
            'pickupsGridMessage',
            appConstants.GRID_STATUS.ERROR
          );
        }
      })
      .catch((_err) => {});
  };

  updatePickupDataBasedOnFeatureFlags = (pickupsList) => {
    let filteredPickupsList = pickupsList?.slice();
    if (!this.props.configJSON?.enableCommentsForCustomer) {
      // Remove shipper comments if feature flag is disabled
      filteredPickupsList = filteredPickupsList.map((pickup) => {
        pickup.shipperComments = null;
        return pickup;
      });
    }
    return filteredPickupsList;
  };

  refreshDispatchRoutes = (driversToUpdate, pickupOperationTimeTrackingId) => {
    const driverIds = sanitizeQueryParams(driversToUpdate);
     RMAXLogger.info(`Fetch Driver Data : ${driverIds.length || "All"}`, {
       driverCount: driverIds.length || 0
     });
    return getDriverRoutesData(this.props.userData.userProfile.terminal.code, driverIds, pickupOperationTimeTrackingId)
      .then((dispatchedDrivers) => {
        if (driverIds?.length) {
          RMAXLogger.info(`Refreshed Driver data : ${driverIds.length}`, {
            driverCount: driverIds.length
          });
          deleteDriversLocationCache(driverIds);
          this.updateDispatchedDrivers(dispatchedDrivers, driverIds);
        } else {
           RMAXLogger.info('Refreshed Driver data: All');
           clearDriverLocationMappingCache();
          this.replaceDispatchedDrivers(dispatchedDrivers);
        }
      }).catch((_err) => {});
  };

  replaceDispatchedDrivers = (dispatchedDrivers) => {
    if (dispatchedDrivers?.status === 200) {
      this.props.DispatchStore.addDispatchedDrivers(
        dispatchedDrivers.data,
        this.props.theme.routeMapColorPalette.IconsColors
      );
      this.props.DispatchStore.showErrorMessageOnGrid(
        "driversRouteGridMessage",
        appConstants.GRID_STATUS.SUCCESS
      );
    } else {
      this.props.DispatchStore.showErrorMessageOnGrid(
        "driversRouteGridMessage",
        appConstants.GRID_STATUS.ERROR
      );
    }
  };

  updateDispatchedDrivers = (dispatchedDrivers, driversToUpdate) => {
    if (dispatchedDrivers?.status === 200) {
      this.props.DispatchStore.updateDispatchedDrivers(
        dispatchedDrivers.data,
        driversToUpdate,
        this.props.theme.routeMapColorPalette.IconsColors
      );
    } 
  };

  refreshDispatchStore = ({
    initialRefresh = false,
    driverIds = null,
    eventName = '',
    refreshPickups = true,
    pickupIds = null,
    pickupOperationTimeTrackingId = null
  } = {}) => {
    const refreshDispatchRoutePromise = this.refreshDispatchRoutes(driverIds, pickupOperationTimeTrackingId);
    const refreshPickupPromise = refreshPickups
      ? this.refreshPickupList(pickupIds)
      : Promise.resolve();

    Promise.all([refreshPickupPromise, refreshDispatchRoutePromise])
      .then(this.dispatchDataRefreshComplete)
      .catch(() => {
        this.triggerHideLoaderDialog();
      });

    if (initialRefresh) {
      this.props.DispatchStore.showErrorMessageOnGrid('all', appConstants.GRID_STATUS.LOADING);
      this.setDataRefreshProgress(true);

      // On initialRefresh, we will invoke these APIs. Subsequently, we will utilize SignalR to trigger further calls.
      Events.emit("refreshUnreadMessages")
      Events.emit("refreshAvailableDrivers");
      Events.emit("RefreshDuplicatePickups");
    }    
   

    if (eventName === "dispatchCancelled") {
      this.props.enqueueSnackbar("Dispatch cancelled successfully", {
        variant: "success",
      });
    }
  };

  dispatchDataRefreshComplete = () => {
    this.triggerHideLoaderDialog();
    this.setDataRefreshProgress(false);
  }  

  stopMoved = (data) => {
    const { routeId, driverId, isEventProcessed } = JSON.parse(data);
    const route = this.props.DispatchStore.getDispatchDriverRoute(
      driverId,
      routeId
    );
    if (isEventProcessed) {
      this.props.enqueueSnackbar(
        `Successfully updated stop sequence for ${route.driverName}, route ${route.routeName}`,
        { variant: "success" }
      );
    } else {
      this.props.enqueueSnackbar(
        `Failed to update stop sequence for driver ${route.driverName}, route ${route.routeName}`,
        { variant: "error" }
      );
    }
    this.updateDriverRoute(driverId).then(() => {
      this.triggerHideLoaderDialog();
    })
  };

  handleChange = (event, value) => {
    this.setState({
      currentTabValue: value,
      proDetails: null
    });
    this.props.router.navigate(this.props.router.location.pathname, { replace: true }); //when we switch tab revert path to original
  };

  onDriverSelectInKPI=( tabName, driverIdList, stopId)=>{
    if(tabName){
   this.setState({
      currentTabValue: tabName,
    },()=>{
      if (driverIdList.length>0) {
         this.props.DispatchStore.updateSelectedDispatchDriver(driverIdList);
        this.props.DispatchStore.setSelectedStopInKPI(stopId)
      }
    });
    }else if (driverIdList.length>0) {
      this.props.glEventHub.emit('SelectDriverRoutes', driverIdList);
      this.props.DispatchStore.setSelectedStopInKPI(stopId)
    }
  }

  onNavigateToToBeReviewedPickup = (payload) => {
    if (this.state.currentTabValue !== appConstants.NAV_URLS.DISPATCH_ROUTEEXECUTION) {
      return;
    }

    this.props.glEventHub.emit(NAVIGATE_TO_TO_BE_REVIEWED_PICKUP_ON_GRID, payload);
  };

  onToastPickupReviewClick = (item, options = {}) => {
    // Dismiss only after Pickups-grid navigation accepts (see GroupPickup).
    Events.emit(
      DISPATCH.NavigateToToBeReviewedPickup,
      buildNavigateToToBeReviewedPayload(item, options)
    );
  };

  onPickupUpdated = (pickupIds, hideLoaderDialog = true) => {
    this.refreshPickupList(pickupIds).then(() => 
      hideLoaderDialog && this.triggerHideLoaderDialog()
    );
  };

  updatePickupListInStore = ({ pickupId, data, success }) => {
    if (success) {
      // Buffered rather than applied immediately — a burst of these arriving close
      // together flushes as one store mutation instead of one per event. The loader
      // dialog signal below is unaffected: it still fires per-event, synchronously,
      // exactly as before.
      // When Swap Board is enabled, handle trailer moves there only: enqueue a remove
      // (falsy data) so they never upsert into pickupsList. Args are (pickupId, data).
      if (shouldHandleAsTrailerMovePickup(data, this.isTrailerSwapBoardEnabled())) {
        this.pickupArrivalBatcher.enqueue(pickupId, null);
      } else {
        const updatedData = this.updatePickupDataBasedOnFeatureFlags([data])[0];
        this.pickupArrivalBatcher.enqueue(pickupId, updatedData);
        alertNewToBeReviewedPickups(
          this.props.DispatchStore,
          this.state.showNotification
        );
      }
    }
    this.triggerHideLoaderDialog();
  };
  
  triggerHideLoaderDialog = () => {
    Events.emit('HideLoaderDialog');
  }; 

  onTerminalChange = (terminal) => {
    const terminalCode = terminal.terminalCode;
    sessionStorage.setItem("selectedTerminal",terminal.terminalId);
    this.props.glEventHub.emit(
      "UpdateDispatchStore",
      "updateSelectedRoutes",
      []
    );
    this.props.glEventHub.emit("DispatchEvents", "RefreshUserInfo", [
      terminal.terminalId,
      `Switched to terminal ${terminalCode}`,
    ]);
    this.setState({
      mainMenuAnchor: null,
    });
    this.populateStaticData(terminalCode);
    this.props.glEventHub.emit("UpdateSpottedTrailers", terminalCode);
  };

  openDriverChatBox = (driver) => {
    // Chat only opens on Route Execution; do not clear message cards elsewhere.
    if (this.state.currentTabValue !== appConstants.NAV_URLS.DISPATCH_ROUTEEXECUTION) {
      return;
    }
    if (driver?.driverId) {
      this.props.DispatchStore.updateNotificationReadStatus(driver.driverId);
    }
    this.props.glEventHub.emit("OpenDriverChatBox", JSON.stringify(driver));
  };



  openModuleSwitcher = (event) => {
    this.setState({ moduleSwitcherAnchor: event.currentTarget });
  };

  onModuleSwitcherClose = () => {
    this.setState({ moduleSwitcherAnchor: null });
  };

  shouldDialogOpen = (title, open = true) => {
    // open dispatchOptimization
    this.setState({
      title: title,
      isDialogOpen: open,
    });
    if (title === "dispatchOptimization") {
      this.setState({
        isPickupOptimizationInProgress: true,
      });
    }
  };

  closeDialog = () => {
    this.setState({
      isDialogOpen: false,
    });
    if (this.state.isPickupOptimizationInProgress) {
      this.setState({
        isPickupOptimizationInProgress: false,
      });
    }
  };

  getDialogComponent = (title) => {
    if (title === "dispatchOptimization") {
      return (
        <DispatchOptimizationDialog
          onClose={this.closeDialog}
          userData={this.props.userData}
          glEventHub={this.props.glEventHub}
        />
      );
    }
    return "";
  };

  openMainMenu = (event) => {
    this.setState({ mainMenuAnchor: event.currentTarget });
  };

  closeMainMenu = () => {
    this.setState({ mainMenuAnchor: null });
  };

  updateGeofenceArrivalDeparture = (data) => {
    this.props.DispatchStore.updateGeofenceArrivalDeparture(data)
  }

  updateDriverGateinGateout = (data) => {
    this.props.DispatchStore.updateDriverGateinGateout(data);
  }

  showProDetails = (eventData) => {
    const data = {
      apiName: 'GetDeliveryStopData',
      queryParams: `terminalCode=${this.props.userData.userProfile.terminal.code}&routeId=${eventData.driverRouteDetails.routeId}&stopId=${eventData.stopId}&shipmentId=${eventData.shipmentId}`,
      proId: eventData.proId,
      driverRouteDetails: eventData.driverRouteDetails
    };
    this.props.router.navigate(`?proId=${eventData.proId}`, {
      state: {
        data: cloneDeep(data)
      }
    });
  };

  setDataRefreshProgress = (isDataRefreshProgress) => {
    if (this.state.isDataRefreshProgress === isDataRefreshProgress) {
      return;
    }
    this.setState({
      isDataRefreshProgress
    });
  };

  render() {
    const { moduleSwitcherAnchor, mainMenuAnchor } =
      this.state;
    const { classes } = this.props;
    const menuProps = {
      openSettings: this.handleChange,
      shouldDialogOpen: this.shouldDialogOpen,
      currentTerminalId: this.props.userData.userProfile.terminal.id,
      isDataRefreshProgress: this.state.isDataRefreshProgress,
      handleTerminalClick: this.handleTerminalClick,
      closeMenu: this.closeMainMenu,
      userProfile: this.userProfileData,
      openDriverChatBox: this.openDriverChatBox,
      onTerminalChange: this.onTerminalChange,
      userData: this.props.userData,
    };
    const showDispatchNotificationsHeaderIcon =
      !this.state.currentTabValue?.includes?.("reports");
    return (
      <div>
        {this.state.currentTabValue &&
          this.state.currentTabValue != this.props.router.location.pathname && (
            <Navigate to={this.state.currentTabValue} />
          )}
        <AppBar
          position="sticky"
          className="appHeader"
          classes={{ root: classes.headerStyles }}
        >
          <Toolbar variant="dense" classes={{ gutters: classes.gutters }}>
            <div>
              <IconButton
                disableRipple={true}
                color="primary"
                onClick={this.openModuleSwitcher}
                data-automationid="hamburger-menu"
              >
                <Tooltip title="Switch Modules">
                  {/* <ViewList className={classes.mainMenu}/> */}
                  <i
                    className={`${classes.moduleSwitcher} icon-icon_burger_menu`}
                  />
                </Tooltip>
              </IconButton>
              <ModuleSwitcher
                menuAnchor={moduleSwitcherAnchor}
                onClose={this.onModuleSwitcherClose}
                handleModuleChange={this.handleChange}
                userProfile={this.props.userData.userProfile}
              />
            </div>
            <img
              className={classes.rmaxLogo}
              src="../../images/RouteMax_Logo_Orange_v2.svg"
            />
            <Tabs
              value={
                [
                  DispatchTabs.assetManagement.path,
                  DispatchTabs.routeExecution.path,
                  DispatchTabs.driverPerformance.path,
                ].includes(this.state.currentTabValue)
                  ? this.state.currentTabValue
                  : false
              }
              classes={{
                root: classes.tabsRoot,
                indicator: classes.tabsIndicator,
              }}
              onChange={this.handleChange}
            >
              <Tab
                value={DispatchTabs.routeExecution.path}
                label={DispatchTabs.routeExecution.label}
                id={DispatchTabs.routeExecution.id}
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected,
                }}
              />
              <Tab
                value={DispatchTabs.assetManagement.path}
                label={DispatchTabs.assetManagement.label}
                id={DispatchTabs.assetManagement.id}
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected,
                }}
              />
              <Tab
                value={DispatchTabs.driverPerformance.path}
                label={DispatchTabs.driverPerformance.label}
                id={DispatchTabs.driverPerformance.id}
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected
                }}
              />
            </Tabs>
            <div className={classes.grow}></div>
            <div className={classes.headerIcons}>
              {this.state.currentTabValue === appConstants.NAV_URLS.DISPATCH_ROUTEEXECUTION ? (
                <div className={classes.refreshIconContainer}>
                  <RefreshIconButton
                    isRefreshing={this.state.isDataRefreshProgress}
                    onRefresh={this.resetDispatchData}
                  />
                </div>
              ) : null}

              <div className={classes.rightNavMenuContainer}>        
                <RightNavigationMenu
                  {...menuProps}
                  switchNotificationPanel={this.switchNotificationPanel}
                  showNotification={this.state.showNotification}
                  showDispatchNotificationsHeaderIcon = {showDispatchNotificationsHeaderIcon}
                />
              </div>
                <Menu
                  disablePortal={true}
                  getContentAnchorEl={null}
                  disableAutoFocusItem={true}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                  open={Boolean(mainMenuAnchor)}
                  anchorEl={mainMenuAnchor}
                  onClose={this.closeMainMenu}
                  MenuListProps={{ disablePadding: true }}
                  classes={{
                    paper: classes.mainMenu,
                  }}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <RightNavigationMenu
                    {...menuProps}
                    switchNotificationPanel={this.switchNotificationPanel}
                    showNotification={this.state.showNotification}
                    showDispatchNotificationsHeaderIcon = {showDispatchNotificationsHeaderIcon}
                  />
                </Menu>
              {this.state.showNotification ? null : (
                <ToastNotifications
                  openDriverChatBox={this.openDriverChatBox}
                  onPickupReviewClick={this.onToastPickupReviewClick}
                />
              )}
            </div>
            <div className={classes.toggledMenu}>
              <IconButton
                color="inherit"
                className={classes.mainMenuButton}
                onClick={this.openMainMenu}
              >
                <Tooltip title="Main Menu">
                  <MoreVert style={{ fontSize: "21px" }} />
                </Tooltip>
              </IconButton>
            </div>
          </Toolbar>
          <Suspense fallback={<AppLoading />}>
            {this.state.isDialogOpen &&
              this.state.title &&
              this.getDialogComponent(this.state.title)}
            <PickupEventHandler
              enableHidePickupLoaderOnSignalR={this.props.featureFlags?.isFeatureEnabled?.(appConstants.features.EnableHidePickupLoaderOnSignalR)}
              enableTrailerSwapBoard={this.isTrailerSwapBoardEnabled()}
              refreshDispatchStore={this.refreshDispatchStore}
              setDataRefreshProgress={this.setDataRefreshProgress}
              isPickupOptimizationInProgress={this.state.isPickupOptimizationInProgress}
              DispatchStore={this.props.DispatchStore}
              enqueueSnackbar={this.props.enqueueSnackbar}
              isNotificationPanelOpen={this.state.showNotification}
              terminalCode={this.props.userData.userProfile.terminal.code}
            />
          </Suspense>
        </AppBar>
        <ParameterListener
          scenarioId={this.props.userData.userProfile.scenarioID}
        />    
        <PickupConfirmationHandler />
      </div>
    );
  }
}
export default compose(
  withWidth(),
  withTheme(),
  withStyles(styles),
  withUserProfile,
  withSnackbar,
  withAppConfig, 
  withRouter,
  withFeatureFlags
)(DispatchHeader);
